export { default } from './CirculatingIcon';



// WEBPACK FOOTER //
// ./src/icons/CirculatingIcon/index.js